import I18n from '@module/i18n';

import Links from '@component/navigation/links';

const getThumbnailURL = (user) => {
  if (user.profile_picture && user.profile_picture.thumbnail_url) {
    return user.profile_picture.thumbnail_url;
  }
  return user.defaults.profile_picture_thumbnail_url;
};

const insertItemAfter = ({ index, items, item }) => {
  const clone = items.slice();
  clone.splice(index, 0, item);
  return clone;
};

export default {
  replaceUnlimitedTrk: (navigation, itemKey) => {
    return {
      ...navigation,
      [itemKey]: {
        ...navigation[itemKey],
        items: navigation[itemKey].items.map((item) => {
          if (item.path === '/plus') {
            return {
              ...item,
              trk: 'WT201806_AboutPlus',
            };
          }
          return item;
        }),
      },
    };
  },
  attachSigninLink: (navigation) => {
    return {
      ...navigation,
      account: {
        ...navigation.account,
        name: I18n.t('navigation.signin.name'),
        trackEvent: {
          category: 'plus',
          action: 'click_signin',
        },
      },
    };
  },
  replaceProfileName: (navigation, contentKey) => {
    const name = contentKey.length > 0 ? I18n.t(contentKey) : '';
    return {
      ...navigation,
      account: {
        ...navigation.account,
        name,
      },
    };
  },
  removePlusPageLink: (navigation, itemKey) => {
    return {
      ...navigation,
      [itemKey]: {
        ...navigation[itemKey],
        items: navigation[itemKey].items.filter((item) => {
          return item.path !== '/plus';
        }),
      },
    };
  },
  attachSignoutLink: (navigation) => {
    return {
      ...navigation,
      account: {
        ...navigation.account,
        // Didn't use #push as it mutates the original object
        items: insertItemAfter({
          index: navigation.account.items.length,
          item: Links.signoutItem,
          items: navigation.account.items,
        }),
      },
    };
  },
  attachUpgradeLink: (navigation) => {
    return {
      ...navigation,
      upgrade: {
        name: I18n.t('navigation.about_us.items.upgrade'),
        path: '/plus',
        trk: 'WT201908_Upgrade',
      },
    };
  },
  attachFeatureInboxLink: (navigation) => {
    return {
      ...navigation,
      account: {
        ...navigation.account,
        items: insertItemAfter({
          index: 1,
          items: navigation.account.items,
          item: Links.inboxItem,
        }),
      },
    };
  },
  attachFeatureSpacesLink: (navigation) => {
    return {
      ...navigation,
      account: {
        ...navigation.account,
        items: insertItemAfter({
          index: 1,
          items: navigation.account.items,
          item: Links.spacesItem,
        }),
      },
    };
  },
  attachChannelName: (navigation, channelName) => {
    return {
      ...navigation,
      account: {
        ...navigation.account,
        name: channelName,
        hasChannelName: true,
      },
    };
  },
  attachAccountMenu: (navigation, user) => {
    // Basic account menu structure:
    // ---
    // Account:
    // |-- Transfer
    // |-- Contacts
    // `-- Account

    return {
      ...navigation,
      account: {
        name: I18n.t('navigation.signed_in.name'),
        notificationDetails: ['onboarding_success', 'already_signed_in'],
        image: getThumbnailURL(user),
        items: [Links.transfersItem, Links.contactsItem, Links.accountItem],
        hasChannelName: false,
      },
    };
  },
  attachPlusMenu: (navigation) => {
    // Plus account menu structure:
    // ---
    // Account:
    // |-- Transfer
    // |-- Plus Feature 1 .. n
    // |-- Contacts
    // |-- Profile
    // `-- Account

    navigation = {
      ...navigation,
      account: {
        ...navigation.account,
        items: insertItemAfter({
          index: -1,
          items: navigation.account.items,
          item: Links.profileItem,
        }),
      },
    };

    return navigation;
  },
};
